import axios from '../utils/axios';

export default function addFollowupCredit(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/user/admin/followup`, body);
}